export default {
      id: "input-file-usage",
      viewBox: "0 0 18 19",
      url: __webpack_public_path__ + "assets/img/svg/sprite.svg#input-file",
      toString: function () {
        return this.url;
      }
    }